module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_1_2.678f2668.png";